module.exports = __webpack_public_path__ + "img/logo_utp.0f3cdde3.png";